import React from "react";
import NavBar from "../../layout/NavBar";
const layoutWrapper = Component => {
  class layoutWrapper extends React.Component {
    render() {
      return (
        <div>
          <NavBar />
          <Component {...this.props} />
        </div>
      );
    }
  }

  return layoutWrapper;
};

export default layoutWrapper;



// WEBPACK FOOTER //
// ./src/components/Hoc/layoutWrapper.js